/**
 * Where a mission blocked on a human DECISION is opened when it has no mail thread
 * to land on: its own card in « Il faut que tu tranches » (/admin/travail), which the
 * page expands and scrolls to. The mission id travels in the URL (principle 5 — the
 * URL is state), so the link is shareable and survives a reload.
 */
export const MISSION_FOCUS_PARAM = 'mission';

export function missionDecisionHref(threadId: string): string {
  return `/admin/travail?${MISSION_FOCUS_PARAM}=${encodeURIComponent(threadId)}`;
}
